import { Trans } from "@/plugins/Translation";

const required = (name) => {
  let message = ""
  if(Trans.currentLocale==="es"){
    message = "Debes ingresar un(a) "
  }else{
    message = "You must enter a "
  }
  return (value) => !!value || message + name.toLowerCase() + ".";
};

const email = () => {
  let message = ""
  if(Trans.currentLocale==="es"){
    message = "Correo inválido."
  }else{
    message = "Invalid email."
  }
  let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (v) => (v && regex.test(v)) || message;
};

const selectedRadio = (valor) =>{
  return (value) => !!value || valor ;
}

export default {
  required,
  email,selectedRadio
};
